import { post, upload } from 'pc-sales/utils/http';

export class CommonApi {

    // // 获取系统ip信息
    // ip = () => get('/v2/common/location/ip');

    // // 获取区域地址列表
    // location = (data?: {
    //     location_type?: '1' | '2' | '3';
    //     parent_id?: string;
    // }) => get('/v2/common/location', data);

    upload = (data: {
        file: Blob;
    }) => upload('/v2/common/file/upload', data);

    // 谷歌翻译
    googleTrans = (data: {
        query: string,
        to_lang: string,
        from_lang?: string
    }) => post('/v2/common/translate/googleTrans', data);
}

export default new CommonApi();
